<template>
  <Transition name="toast">
    <div v-if="message" class="toast" role="status" aria-live="polite">
      {{ message }}
    </div>
  </Transition>
</template>

<script>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Toast',
  setup() {
    const store = useStore()
    const message = computed(() => store.state.toast?.message || '')

    watch(message, (val) => {
      if (!val) return
      const t = setTimeout(() => {
        store.commit('setToast', '')
      }, 3500)
      return () => clearTimeout(t)
    })

    return { message }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.toast {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  max-width: calc(100vw - 48px);
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 500;
  color: $color-primary-inverse;
  background: $color-accent-teal;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  z-index: 4000;
  pointer-events: none;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(12px);
}
</style>
